// extracted by mini-css-extract-plugin
module.exports = {"facultyCard":"styles_facultyCard__AGmOl","arrowIcon":"styles_arrowIcon___bBaE","arrowHover":"styles_arrowHover__frylP","facultyImage":"styles_facultyImage__Y2qow"};